export const safeDecodeToken = (token) => {
    try {
        if (!token) return null;
        const segments = token.split(".");
        if (segments.length < 2) return null;
        let payload = segments[1].replace(/-/g, "+").replace(/_/g, "/");
        const pad = payload.length % 4;
        if (pad) {
            payload += "=".repeat(4 - pad);
        }
        const decoder =
            (typeof window !== "undefined" && typeof window.atob === "function")
                ? window.atob
                : (typeof atob === "function" ? atob : null);
        if (!decoder) return null;
        const json = decoder(payload);
        return JSON.parse(json);
    } catch (error) {
        console.warn("safeDecodeToken failed:", error);
        return null;
    }
};